import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BoltIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M15.5498 2.66L13.9498 10.08H20.7498L10.9098 21.28H8.44977L10.0498 13.86H3.24977L13.0898 2.66H15.5498ZM11.9898 11.52L13.5298 4.52L6.62977 12.42H12.0098L10.4698 19.42L17.3698 11.52H11.9898Z" />
    </SvgIcon>
  );
});
